import React from 'react';

import { Channel } from '@kaltura-ott/tvpil-shared';

import { Card, CardBubbleInfo, CardInner, CardTitle } from 'components/presenters';

import HeroCardContent from '../HeroCardContent/HeroCardContent';

import { useHeroCard } from './hooks/useHeroCard/useHeroCard';

interface Props {
  channel: Channel;
  itemWidth: number;
  imageHeight: number;
  timestamp: number;
  index: number;
}

function HeroCard({ channel, itemWidth, imageHeight, timestamp, index }: Props) {
  const {
    link,
    title,
    isAdult,
    isRecord,
    imageUrl,
    ariaLabel,
    handleRef,
    liveProgram,
    clickHandler,
    onMouseEnter,
    onMouseLeave,
    handleLinkRef,
    isSeriesRecord,
    channelLogoUrl,
    defaultImageUrl,
    handleClickInfo,
    seasonEpisodeTitle,
    isChannelHasNoProgram,
  } = useHeroCard({ channel, itemWidth, imageHeight, timestamp, index });

  return (
    <Card
      handleLinkRef={handleLinkRef}
      clickHandler={clickHandler}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      link={link}
      ariaLabel={ariaLabel}
      imageHeight={imageHeight}
      itemWidth={itemWidth}
      isMosaicProgram={!!liveProgram?.hasMosaic}
    >
      <CardInner
        defaultImageUrl={defaultImageUrl}
        cardType='hero'
        url={imageUrl}
        name={liveProgram?.title}
        handleRef={handleRef}
        handleLinkRef={handleLinkRef}
        isAdult={isAdult}
        isNoDataWithNoLogoImg={isChannelHasNoProgram}
        contentOverlay={
          <HeroCardContent
            isAdult={isAdult}
            channelHasProgram={!isChannelHasNoProgram}
            channelLogoUrl={channelLogoUrl!}
            channelTitle={channel?.title}
            shouldDisplayCartIcon={!channel.isEntitled}
            shouldDisplayPlayButton={channel.isEntitled}
            shouldDisplayFavoriteIcon={channel.isEntitled && channel.isFavorite}
            startDate={liveProgram?.startDate!}
            endDate={liveProgram?.endDate!}
          />
        }
      />
      <CardBubbleInfo
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        channelHasProgram={!isChannelHasNoProgram}
        isAdult={isAdult}
        seasonEpisodeTitle={seasonEpisodeTitle}
        title={title}
        isMosaicProgram={!!liveProgram?.hasMosaic}
        handleClickInfo={handleClickInfo}
        isLinkAsAsset={false}
      />
      <CardTitle
        isRecord={isRecord}
        isSeriesRecord={isSeriesRecord}
        isAdult={isAdult}
        isStaticInfo
        title={title}
        isMosaicProgram={!!liveProgram?.hasMosaic}
        seasonEpisodeTitle={seasonEpisodeTitle}
      />
    </Card>
  );
}

export default HeroCard;
